



































































import PageHeader from "@/components/PageHeader.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
import { Action, State, Getter } from "vuex-class";
import moment from "moment";
import Callback from "@/components/Call/Callback.vue";
import * as api from "@/lib/api";
import LeadPanel from "@/components/Lead/LeadPanel.vue";
import { User } from "@/types";
import { getUserId } from "@/helpers";
import logger from "../configs/logger";
import { Routes } from "@/router/routes";
import lead from "@/store/actions/lead";

@Component({ components: { PageHeader, LeadPanel, Callback } })
export default class LeadSources extends Vue {
  @Action("getCallHistory") getCallHistory!: Function;
  @Action("getLead") getLead!: Function;
  @State("user") user!: User;
  @State("inCallMode") inCallMode!: boolean;

  snack = false;
  snackColor = "";
  snackText = "";
  activeLeadId: string = "";
  loading = false;
  dialog = false;
  search = "";
  leadSources = [];
  newLeadCost = "";
  headers = [
    { text: "ID", value: "id" },
    { text: "Name", value: "name" },
    { text: "Lead Cost", value: "lead_cost" }
  ];

  @Watch("inCallMode")
  onCallModeChange(val: any, preVal: any) {
    if (val) this.dialog = false;
  }

  get isAdmin() {
    return this.user.roles && this.user.roles.includes("admin");
  }

  mounted() {
    if (!this.isAdmin && this.isAdmin !== undefined) {
      this.$router.push({ name: Routes.DashBoard });
    }

    this.loadLeadSources();
  }

  async handleViewLead(leadId: string) {
    this.activeLeadId = leadId;
    this.dialog = true;
  }

  open(lead_cost: string) {
    this.newLeadCost = lead_cost;
  }

  async save(id: string, lead_cost: string) {
    if (this.isAdmin) {
      const success = await this.updateLeadSourcesCost(
        parseInt(id),
        parseFloat(this.newLeadCost)
      );
      if (success) {
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Lead cost updated";
        this.loadLeadSources();
      }
    } else {
      this.$toasted.error("Admin access only").goAway(2000);
    }
  }

  async updateLeadSourcesCost(id: number, lead_cost: number) {
    try {
      this.loading = true;
      await api.adminUpdateLeadSourcesCost(id, lead_cost);
      return true;
    } catch (err) {
      logger("error", "lead cost update error", err);
      // @ts-ignore
      if (err.response.data.error) {
        this.$toasted.error(err.response.data.error).goAway(2000);
      } else {
        this.$toasted.error("lead cost update error").goAway(2000);
      }
      return false;
    } finally {
      this.loading = false;
    }
  }

  async loadLeadSources() {
    try {
      this.loading = true;
      const { data } = await api.adminGetLeadSources();
      this.leadSources = data;
    } catch (err) {
      logger("error", "lead lookup error", err);
      // @ts-ignore
      if (err.response.data.error) {
        this.$toasted.error(err.response.data.error).goAway(2000);
      } else {
        this.$toasted.error("Lead lookup error").goAway(2000);
      }
    } finally {
      this.loading = false;
    }
  }
}
